












































































































































import _, { toNumber } from 'lodash';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { Doklad } from '@/modules/servis/doklad';
import { printButton, cancelButton} from '@/main/utils/tableOperations';
import { apiProvider } from '@/modules/servis/zakazka/api';
import { showAlert } from '@/main/utils/notifications';
import DmsEditableTable from '#components/dms/layout/EditableTable.vue';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';
import { Cell, cellNames, Column, Table, getColumnsRowMapObject, convertToObjects, Row, EditableStatus } from '@/main/utils/table';
import { store } from '../../store/edit';
import { DefaultCurrency, NAME ,EGUI_OPTIONS, ADVANCE_PAYMENT_ID, MENU_CODE, TAB_ACCESS_CODE, EGUI_TRANS_OPTIONS, EGUI_TYPES} from './constants';
import { ADVANCEPAY, ZAKAZKA_DRUH, ZAKAZKA_STAV } from '../../constants';
import { getStavZakazka } from '../../utils';

export default EditStoreMixin.extend({
	name: 'AdvancePay',
	components: {
		DmsPdfDialog,
		DmsEditableTable,
	},
	props: {
		storeUri: { type: String, default: null },
	},
	data() {
		return {
			NAME,
			DokladName: Doklad.name,
			printButton,
			cancelButton,
			showTiskDialog: false,
			iseGUIApplicable: false,
			iseGUIVisible: false,
			lbleGUI: 'EGUI',
			iseGUIIssuePopUpVisible: false,
			rdbCarrier: '' as string | null,
			rdbEcpayCarrier: '1' as string | null,
			barCode: '' as string | null,
			digitalCertificate: '' as string | null,
			loveCode: '' as string | null,
			Donation: null as string | null,
	        LoveCode: null as string | null,
	        CarrierType: null as string | null,
	        CarrierNum: null as string | null,
			AdvanceEguiPayment: 0 as number,
			advancePaymentId: '' as string | null,
			InvoiceRemark: null as string | null,
	        CustomerIdentifier: null as string | null,
			CustomerName: null as string | null,
			defaultCustomerIdentifier: '' as string | null,
			invoiceRemark: '' as string | null,
			iseGUITypeCompany: false,
			iseGUITypeWithCarrier: false,
			iseGUITypeNoCarrier: false,
			AdvanceTotalPayment: 0 as number,
			DefaultEguiTransDisplayOptions: 2 as number,
		};
	},
	computed: {
		...genVuexComputeds(store),
		isDisabled(): boolean {
			return this.ZakazkaId! < 0 || (!this.CanFakturace || (this.isAdvancePaybtnDisable)) || !this.hasTabWritePermissions;
		},
		hasTabWritePermissions():boolean{
			let result= this.loggedUser.UserTabs.find((menu: any) => menu.MenuCode === MENU_CODE
			&& menu.TabAccessCode.find((code: string) => code === TAB_ACCESS_CODE));
			return result;
		},
		extraButtons(): { } {
			if(this.hasTabWritePermissions) {
				return {
					...printButton(this.eGUIPrintAdvancePaymentInvoice), 
					...cancelButton(this.eGUICancelAdvancePaymentInvoice) 
					};
			}
			return {
					...printButton(this.eGUIPrintAdvancePaymentInvoice)
				};
		},
		isAdvancePaybtnDisable(): boolean {
			return getStavZakazka(this.edit) === ZAKAZKA_STAV.UVOLNENA || getStavZakazka(this.edit) === ZAKAZKA_STAV.UZAVRENA;
		},
		getCurrency() : number | null {
			this.MenaId2 = (this.dropdownList.MenaId2 as any).filter((x:any) => x.Text === DefaultCurrency.PrimaryText || x.Text === DefaultCurrency.SecondaryText)[0]?.Value;
			return this.MenaId2;
		},
		isInvoiceOptionVisible(): boolean {
			return this.rdbEcpayCarrier == '0';
		},
		isCinDisabled(): boolean {
			return this.rdbCarrier != '5';
		},
		eGUIActions(): any {
			if (this.lbleGUI === 'EGUI') {
				return {
					issueInvoice: 'EGUI_ISSUE',
				};
			} else {
				return {
					cancelInvoice: 'EGUI_CANCEL',
				};
			}
		},
		isEguiOptionsVisible(): boolean {
			return this.lbleGUI === 'issueInvoice';
		},
	},
	watch: {
		EguiTypes() {
			switch (this.EguiTypes) {
				case EGUI_TYPES.COMPANY: {
					this.iseGUITypeCompany = true;
					this.iseGUITypeWithCarrier = false;
					this.iseGUITypeNoCarrier = false;
					this.rdbEcpayCarrier = '0';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = '';
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = this.DefaultEguiTransDisplayOptions;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
				case EGUI_TYPES.WITH_CARRIER: {
					this.iseGUITypeCompany = false;
					this.iseGUITypeWithCarrier = true;
					this.iseGUITypeNoCarrier = false;
					this.rdbEcpayCarrier = '0';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = '';
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = this.DefaultEguiTransDisplayOptions;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
				case EGUI_TYPES.NO_CARRIER: {
					this.iseGUITypeCompany = false;
					this.iseGUITypeWithCarrier = false;
					this.iseGUITypeNoCarrier = true;
					this.rdbEcpayCarrier = '1';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = '';
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = this.DefaultEguiTransDisplayOptions;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
				default: {
					this.iseGUITypeCompany = false;
					this.iseGUITypeWithCarrier = false;
					this.iseGUITypeNoCarrier = false;
					this.rdbEcpayCarrier = '';
					this.rdbCarrier = '';
					this.CustomerName = '';
					this.invoiceRemark = '';
					this.loveCode = '';
					this.barCode = '';
					this.digitalCertificate = '';
					this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
					this.EguiTransDisplayOptions = this.DefaultEguiTransDisplayOptions;
					this.CashAmount = 0;
					this.CreditAmount = 0;
					this.DebitAmount = 0;
					this.OnlineAmount = 0;
					this.AdvanceTotalPayment = 0;
					break;
				}
			}
		},
		CashAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.CashAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CreditAmount, 0).toString()) + parseFloat(_.defaultTo(this.DebitAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
		CreditAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.CreditAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.DebitAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
		DebitAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.DebitAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
		OnlineAmount() {
			if (Number.isNaN(parseFloat(_.defaultTo(this.OnlineAmount, 0).toString()))) {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString());
			} else {
				this.AdvanceTotalPayment = parseFloat(_.defaultTo(this.CashAmount, 0).toString()) + parseFloat(_.defaultTo(this.CreditAmount, 0).toString())
				+ parseFloat(_.defaultTo(this.DebitAmount, 0).toString()) + parseFloat(_.defaultTo(this.OnlineAmount, 0).toString());
			}
		},
	},
	methods: {
		loadedData() {
			this.EguiTransDisplayOptions = this.DefaultEguiTransDisplayOptions;
		},
		onEguiOptionChange() {
			if (this.rdbEcpayCarrier == '1') {
				this.rdbCarrier = '';
				this.CustomerIdentifier = this.defaultCustomerIdentifier;
				this.CustomerName = '';
				this.invoiceRemark = '';
				this.loveCode = '';
				this.barCode = '';
				this.digitalCertificate = '';
			} else if (this.rdbEcpayCarrier == '0') {
				this.loveCode = '';
				this.barCode = '';
				this.digitalCertificate = '';
				this.invoiceRemark = '';
				this.CustomerName = '';
				this.CustomerIdentifier = this.defaultCustomerIdentifier != null && this.defaultCustomerIdentifier != '' ? this.defaultCustomerIdentifier : null;
			}
		},
		async oneGUIOptionSelected() {
			 if (this.rdbEcpayCarrier === '' || (this.rdbEcpayCarrier == '0' && this.rdbCarrier === '')) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: this.LocalizeChyboveHlasky('eGUIOptionSelect'),
					options: { type: 'error' },
				});
			} else if ((this.EGUIInvoiceNumber === '' || this.EGUIInvoiceNumber === null) && (this.lbleGUI === EGUI_OPTIONS.EGUI_PRINT || this.lbleGUI === EGUI_OPTIONS.EGUI_CANCEL)) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					message: this.LocalizeChyboveHlasky('eGUIIssueFirst'),
					options: { type: 'info' },
				});
			} else if (this.rdbEcpayCarrier == '1') {
				this.eGUIIssueInvoice();
			} else if (this.lbleGUI === EGUI_OPTIONS.EGUI_ISSUE) {
				if (this.barCode !== '' && this.isBarCodeValid(this.barCode!)) {
					const loading = this.$loading({ fullscreen: true });
					const eGUICheckBarcodeRequestDTO = {
						BarCode: this.barCode,
						ZakazkaId: this.ZakazkaId
					};
					const { data: response } = await apiProvider.eGUICheckBarcode(eGUICheckBarcodeRequestDTO);
					loading.close();
					if (response !== null && response !== '' && response.RtnCode === 1 && response.IsExist === 'Y') {
						this.eGUIIssueInvoice();
					} else {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: this.LocalizeChyboveHlasky('eGUIBarcodeInvalid'),
							options: { type: 'error' },
						});
					}
				} else if (this.digitalCertificate !== '' && this.isDigitalCertificateValid(this.digitalCertificate!)) {
					this.eGUIIssueInvoice();
				} else if (this.loveCode !== '' && this.isLoveCodeValid(this.loveCode!)) {
					this.eGUIIssueInvoice();
				} else if (this.rdbCarrier == '5') {
					if (this.rdbCarrier == '5' && (this.CustomerIdentifier == null || this.CustomerIdentifier == '')) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('Egui_CIN_Required_Error')}`,
							options: { type: 'error' },
						});
					} else this.eGUIIssueInvoice();
				} else {
					if ((this.rdbCarrier == '3' && this.barCode === '') || (this.barCode !== '' && !this.isBarCodeValid(this.barCode!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIBarcodeInvalid')}`,
							options: { type: 'error' },
						});
					} else if ((this.rdbCarrier == '2' && this.digitalCertificate === '') || (this.digitalCertificate !== '' && !this.isDigitalCertificateValid(this.digitalCertificate!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIDigiCertInvalid')}`,
							options: { type: 'error' },
						});
					} else if ((this.rdbCarrier == '4' && this.loveCode === '') || (this.loveCode !== '' && !this.isLoveCodeValid(this.loveCode!))) {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUILoveCodeInvalid')}`,
							options: { type: 'error' },
						});
					} else {
						this.showErrorAlert({
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							message: `${this.LocalizeChyboveHlasky('eGUIIssueInvalidInp')}`,
							options: { type: 'error' },
						});
					}
				}
			} else if (this.lbleGUI === EGUI_OPTIONS.EGUI_PRINT) {
				this.eGUIPrintInvoice();
			} else if (this.lbleGUI === EGUI_OPTIONS.EGUI_CANCEL) {
				this.eGUICancelInvoice();
			} else {
				this.eGUIIssueInvoice();
			}
		},
		isEGUIOptionAvailable(): boolean {
			return (this.ZakazkaDruh !== ZAKAZKA_DRUH.GARANCE && this.ZakazkaDruh !== ZAKAZKA_DRUH.KULANCE
			&& this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND);
		},
		async eGUIIssueInvoice() {
			if (this.AdvanceTotalPayment == null || this.AdvanceTotalPayment == 0 || Number.isNaN(this.AdvanceTotalPayment)) {
				showAlert({
					message: this.LocalizeChyboveHlasky('AdvancePayValidate'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return false;
			}
			if (this.AdvanceTotalPayment != this.AdvanceEguiPayment!) {
				showAlert({
					message: this.LocalizeChyboveHlasky('AdvancePayWrongAmt'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: { type: 'info' },
				});
				return false;
			}
			if (this.EguiTransDisplayOptions == null || this.EguiTransDisplayOptions == 0) {
				this.showErrorAlert({
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					message: `${this.LocalizeChyboveHlasky('eGUITransDetailsInvalid')}`,
					options: { type: 'error' },
				});
				return false;
			}

			const eGUIIssueInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
				Donation: this.rdbCarrier == '4' ? '1' : '0',
				LoveCode: this.loveCode,
				CarrierType: this.rdbEcpayCarrier == '0' ? this.rdbCarrier : this.rdbEcpayCarrier,
				CarrierNum: (this.rdbCarrier == '2' ? this.digitalCertificate : (this.rdbCarrier == '3' ? this.barCode : '')),
				TaxType: 1,
				// SpecialTaxType: 0,
				SalesAmount: this.AdvanceEguiPayment,
				invoiceRemark: this.invoiceRemark,
				InvType: '07',
				vat: 1,
				CustomerIdentifier:this.rdbEcpayCarrier=='1'? null : this.CustomerIdentifier,
				CustomerName:this.rdbEcpayCarrier=='1'? null : this.CustomerName,
			};

			this.iseGUIIssuePopUpVisible = false;
			this.iseGUIVisible = false;
			const loading = this.$loading({ fullscreen: true });
			this.Donation = this.rdbCarrier == '4' ? '1' : '0';
			this.LoveCode = this.loveCode;
			this.CarrierType = this.rdbEcpayCarrier == '0' ? this.rdbCarrier : this.rdbEcpayCarrier;
			this.CarrierNum = (this.rdbCarrier === '2' ? this.digitalCertificate : (this.rdbCarrier == '3' ? this.barCode : ''));
			const response = await apiProvider.eGUIIssueInvoiceAdvancePayment(eGUIIssueInvoiceRequestDTO,this.AdvanceEguiPayment);
			loading.close();
			if (this.loveCode === '' && this.barCode === '' && this.digitalCertificate === '') {
				if (response !== null && response.data !== '') {
					if (response.data.RtnCode === 1) {
						const message = `${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${this.LocalizeChyboveHlasky('eGUIPrintReceipt')}`;
						const questionResult = await this.showConfirm({
							title: this.LocalizePopisostatni('CRMDotaz'),
							message: message,
							options: {
								confirmButtonText: this.Localize('Ano'),
								cancelButtonText: this.Localize('Ne'),
							},
						});
						if (questionResult) {
							this.eGUIPrintInvoice();
						}
					} else {
						this.showErrorAlert({
							title: '',
							message: `${this.LocalizeChyboveHlasky('eGUIIssueFail')} ${response.data.RtnMsg}`,
							options: { type: 'error' },
						});
					}
				} else {
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('eGUIIssueFail')} ${response}`,
						options: { type: 'error' },
					});
				}
			} else if (response !== null && response.data !== '') {
				if (response.data.RtnCode === 1) {
					const eguiList = response.data.CarrierEguiNumbers?.length
						? response.data.CarrierEguiNumbers.join(', ')
						: '';
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('eGUIIssueSuccess')} ${''} ${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
						options: { type: 'info' },
					});
				} else if (response.data.RtnMsg !== '') {
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('eGUIIssueFail')} ${response.data.RtnMsg}`,
						options: { type: 'error' },
					});
				}
			}
		},
		async eGUICancelInvoice() {
			this.iseGUIIssuePopUpVisible = false;
			this.iseGUIVisible = false;
			const loading = this.$loading({ fullscreen: true });
			const eGUICancelInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
			};
			const { data: response } = await apiProvider.eGUICancelInvoice(eGUICancelInvoiceRequestDTO);
			loading.close();
			if (response !== null && response !== '' && response.RtnCode === 1) {
				this.showErrorAlert({
					title: '',
					message: `${this.LocalizeChyboveHlasky('eGUICancelSuccess')}`,
					options: { type: 'info' },
				});
			} else {
				this.showErrorAlert({
					title: '',
					message: this.LocalizeChyboveHlasky('eGUICancelFail'),
					options: { type: 'error' },
				});
			}
			setTimeout(() => {
				//this.recomputeHash();
				this.refreshPreviousPage = true;
				this.$router.go(-1);
			}, 5000);
		},

		async eGUICancelAdvancePaymentInvoice(e: Event, cells: Cell[]) {
			const loading = this.$loading({ fullscreen: true });
			const {data:isEguiCreated} = await apiProvider.isEGUICreated(this.ZakazkaId,cells[0]);
			loading.close();
			if(isEguiCreated){
			this.iseGUIIssuePopUpVisible = false;
			this.iseGUIVisible = false;
			const loading = this.$loading({ fullscreen: true });
			const eGUICancelInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
			};
			const { data: response } = await apiProvider.eGUICancelAdvancePaymentInvoice(eGUICancelInvoiceRequestDTO,cells[0]);
			loading.close();
		if (response !== null && response.EguiCancellationSkipped === true){
    		this.showErrorAlert({
				title: '',
				message: this.LocalizeChyboveHlasky(
					'prePaymentRemovedEGUIActive'
				),
				options: { type: 'info' },
    		});
		}
		else if (response !== null && response !== '' && response.RtnCode === 1) {
				this.showErrorAlert({
					title: '',
					message: `${this.LocalizeChyboveHlasky('eGUICancelSuccess')}`,
					options: { type: 'info' },
				});
			} else {
				this.showErrorAlert({
					title: '',
					message: this.LocalizeChyboveHlasky('eGUICancelFail'),
					options: { type: 'error' },
				});
			}
		}
		else{
			const message = `${this.LocalizeChyboveHlasky('eguiDoesNotExists')} ${this.LocalizeChyboveHlasky('doYouwishToDeleteAdvancePayment')}`;
					const questionResult = await this.showConfirm({
						title: this.LocalizePopisostatni('CRMDotaz'),
						message: message,
						options: {
							confirmButtonText: this.Localize('Ano'),
							cancelButtonText: this.Localize('Ne'),
						},
					});
					if (questionResult) {
						const loading = this.$loading({ fullscreen: true });
						 var cancelAdvancePayment = await apiProvider.cancelAdvancePayment(this.ZakazkaId,cells[0]);
						 loading.close();
					}
		}
			this.loadingCount += 1;
			await this.refreshTable(ADVANCEPAY);
			this.loadingCount -= 1;
		},
		async eGUIPrintAdvancePaymentInvoice(e: Event, cells: Cell[]) {
			const loading = this.$loading({ fullscreen: true });
			const { data: isEguiCreated } = await apiProvider.isEGUICreated(this.ZakazkaId, cells[0]);
			loading.close();
			if (isEguiCreated) {
				this.iseGUIIssuePopUpVisible = false;
				this.iseGUIVisible = false;
				const loading = this.$loading({ fullscreen: true });
				const eGUIPrintInvoiceRequestDTO = {
					ZakazkaId: this.ZakazkaId,
				};
				const { data: response } = await apiProvider.eGUIPrintAdvancePaymentInvoice(eGUIPrintInvoiceRequestDTO,cells[0]);
				loading.close();
				if (response !== null && response !== '' && response.RtnCode === 1) { // success
					const invoiceItems = response?.InvoiceHtmlForSplit.split(',');
					for (let iItem = 0; iItem < invoiceItems.length; iItem++) {
						window.open(invoiceItems[iItem], '_blank');
					}
				} else if (response.RtnCode === EGUI_OPTIONS.EGUI_RTN_CODE) {
					const eguiList = response?.CarrierFailedEguiNumbers?.length ? response.CarrierFailedEguiNumbers.join(', ') : '';
					this.showErrorAlert({
						title: '',
						message: `${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
						options: { type: 'info' },
					});
				} else {
					this.showErrorAlert({
						title: '',
						message: this.LocalizeChyboveHlasky('eGUIPrintFail'),
						options: { type: 'error' },
					});
				}
			} else {
				this.showErrorAlert({
					title: '',
					message: this.LocalizeChyboveHlasky('eguiDoesNotExists'),
					options: { type: 'error' },
				});
			}
		},
		async eGUIPrintInvoice() {
			this.iseGUIIssuePopUpVisible = false;
			this.iseGUIVisible = false;
			const loading = this.$loading({ fullscreen: true });
			const eGUIPrintInvoiceRequestDTO = {
				ZakazkaId: this.ZakazkaId,
			};
			const { data: response } = await apiProvider.eGUIPrintAdvancePaymentInvoice(eGUIPrintInvoiceRequestDTO,this.advancePaymentId);
			loading.close();
			if (response !== null && response !== '' && response.RtnCode === 1) { // success
				const invoiceItems = response?.InvoiceHtmlForSplit.split(',');
				for (let iItem = 0; iItem < invoiceItems.length; iItem++) {
					window.open(invoiceItems[iItem], '_blank');
				}
			} else if (response.RtnCode === EGUI_OPTIONS.EGUI_RTN_CODE) {
				const eguiList = response?.CarrierFailedEguiNumbers?.length ? response.CarrierFailedEguiNumbers.join(', ') : '';
				this.showErrorAlert({
					title: '',
					message: `${this.LocalizeChyboveHlasky('printingNotAllowed')}${eguiList}`,
					options: { type: 'info' },
				});
			} else {
				this.showErrorAlert({
					title: '',
					message: this.LocalizeChyboveHlasky('eGUIPrintFail'),
					options: { type: 'error' },
				});
			}
		},
		isBarCodeValid(barCode: string): boolean {
			const emailRegExp = new RegExp('^/[A-Z0-9.\\-+]{7}$');
			return emailRegExp.test(barCode);
		},
		isDigitalCertificateValid(certificateCode: string): boolean {
			const emailRegExp = new RegExp('^[A-Z]{2}[0-9]{14}$');
			return emailRegExp.test(certificateCode);
		},
		isLoveCodeValid(loveCode: string): boolean {
			const emailRegExp = new RegExp('^[0-9]{3,7}$');
			return emailRegExp.test(loveCode);
		},
		async onIssueClick() {
			if (this.lbleGUI === EGUI_OPTIONS.EGUI_ISSUE) {
				this.iseGUIIssuePopUpVisible = true;
			}
		},
		async saveAdvancePay() {
			if (this.ZakazkaId! > 0) {
				if (this.AdvancePayment === null || this.AdvancePayment <= 0 || this.MenaId2 === null
					|| this.MenaId2 < 0 || this.PlatbaPzn === null || this.PlatbaPzn < 0) {
					showAlert({
						message: this.LocalizeChyboveHlasky('NePrazdnePole'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				} else if (!(/^(\d+\.)?\d+$/.test(this.AdvancePayment.toString()))) {
					showAlert({
						message: this.LocalizeChyboveHlasky('AdvancePayValidate'),
						title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
						options: { type: 'info' },
					});
				} else {
					this.AdvanceEguiPayment = this.AdvancePayment;
					this.loadingCount += 1;
					this.isDisabled = true;
					const Uploadresult = await apiProvider.saveAdvancePay(this.edit);
					this.loadingCount -= 1;
					if (Uploadresult) {
						this.AdvancePayment = null;
						this.MenaId2 = null;
						this.PaymentReferenceNumber = null;
					     await showAlert({
							message: this.LocalizeChyboveHlasky('AdvancePaySave'),
							title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
							options: { type: 'info' },
						});
						this.loadingCount += 1;
						await this.refreshTable(ADVANCEPAY);
						this.loadingCount -= 1;
						if (this.edit.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT) {
							await apiProvider.sendAdvancePaymentNotification(this.ZakazkaId);
						}
						const { data: isCustomerDealerInternal } = await apiProvider.isCustomerTyperInternal(this.ZakaznikId);
						if (isCustomerDealerInternal) {
							return;
						}

						const loading = this.$loading({ fullscreen: true });
						const { data } = await apiProvider.getCustomerIdentifier(this.ZakaznikId);
						loading.close();
						this.CustomerIdentifier = data;
						this.defaultCustomerIdentifier = data;
						this.isDisabled = false;
						if (this.isEGUIOptionAvailable()) {
							this.iseGUIIssuePopUpVisible = true;
							this.iseGUIApplicable = true;
							this.lbleGUI = EGUI_OPTIONS.EGUI_ISSUE;
							this.EguiTypes = 0;
						}
					}
				}
			}
		},
		upperCaseValue(value: any) {
			if (value != null) {
				this.barCode = value.toUpperCase();
			}
		},
	},
});
